﻿import { bookerPostBlob } from './bookerFetch.js';
import { showToast } from './toast.js';

let currentPdfBlob = null;
let currentPdfFileName = '';

export function init() {
    initSelectBankHandler();
    initGenerateHandler();
    initReturnHomeHandler();
}

function initSelectBankHandler() {
    const selectBank = document.querySelector('[data-js-field="bankAccountId"]');
    if (!selectBank) return;

    selectBank.addEventListener('change', (event) => {
        const accountId = event.target.value;
        window.location.href = `/BookerAppUser/ExportPDF/Activities?selectedAccountId=${accountId}`;
    })
}

function initGenerateHandler() {
    const btnGenerate = document.getElementById('btnGenerate');
    if (!btnGenerate) return;

    btnGenerate.addEventListener('click', generatePdf);
}

function initReturnHomeHandler() {
    const btnHome = document.getElementById('btnHome');
    if (!btnHome) return;

    btnHome.addEventListener('click', () => {
        const accountId = btnHome.dataset.accountId;
        window.location.href = `/BookerAppUser/BookerDashboard/Index?accountId=${accountId}`;
    })
}

async function generatePdf() {
    const accountId = document.querySelector('[data-js-field="bankAccountId"]').value;
    const startDate = document.querySelector('[data-js-field="periodStartDate"]').value;
    const endDate = document.querySelector('[data-js-field="periodEndDate"]').value;

    if (!startDate || !endDate) {
        showToast('error', "Veuillez sélectionner les dates de début et de fin.");
        return;
    }

    setLoadingState(true);

    const result = await bookerPostBlob(
        '/BookerAppUser/ExportPDF/Activities',
        {
            bankAccountId: parseInt(accountId),
            startDate,
            endDate
        }
    );

    setLoadingState(false);

    if (!result.blob) return;

    currentPdfBlob = result.blob;
    currentPdfFileName = result.fileName ?? `extrait-compte-${Date.now()}.pdf`;

    displayPdf(currentPdfBlob);
}

function displayPdf(blob) {
    const pdfUrl = URL.createObjectURL(blob);
    const iframe = document.getElementById('pdfViewer');
    const viewerCard = document.getElementById('pdfViewerCard');

    iframe.src = pdfUrl;
    viewerCard.classList.remove('d-none');
}

function setLoadingState(isLoading) {
    const btnGenerate = document.getElementById('btnGenerate');
    const btnText = document.getElementById('btnText');
    const btnSpinner = document.getElementById('btnSpinner');

    if (isLoading) {
        btnGenerate.disabled = true;
        btnText.textContent = 'En cours...';
        btnSpinner.classList.remove('d-none');
    } else {
        btnGenerate.disabled = false;
        btnText.textContent = 'Générer';
        btnSpinner.classList.add('d-none');
    }
}